<mat-toolbar class="toolbar-orga __splits_toolbar fixed-top">
  <div class="d-flex flex-row align-items-center justify-content-start container-splits">

    <div class="logo-wrap">
      <a [routerLink]="'/'"><img
        src="/assets/img/app/logo_black.png" alt="Splits" class="logo"></a>
    </div>

    <div class="d-flex ml-auto">

      <div class="d-flex" *ngIf="!user">

        <a [routerLink]="['/']" class="_sp_btn _white">
          <span>Vous êtes un trailer ?</span>
        </a>

        <div class="start-button-wrap">
          <button id="my-account-btn" type="button" class="_sp_btn _blue" i18n [matMenuTriggerFor]="startMenu"
                  matTooltip="Accéder à mon espace organisateur" matTooltipShowDelay="1000" aria-label="Mon compte">
            <span>Mon compte</span>
          </button>

          <!-- this menu starts as hidden by default -->
          <mat-menu #startMenu="matMenu" class="__connexion_menu">
            <button id="btn-signin" mat-menu-item (click)="signIn()">
              <span>Me connecter </span>
            </button>
            <button id="btn-register" mat-menu-item (click)="register()">
              <span>M'inscrire</span>
            </button>
            <mat-divider></mat-divider>
            <button id="btn-create-race" mat-menu-item (click)="register()">
              <i class="fa-solid fa-person-running"></i>
              <span>Créer une course</span>
            </button>
            <button id="btn-faq" mat-menu-item (click)="faq()">
              <i class="fa-regular fa-circle-question text-success"></i>
              <span>Aide</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <!-- notification widget-->
      <div class="jewel-button d-flex align-items-center">
        <!--        <notification-widget></notification-widget>-->
      </div>

      <div class="account-wrap d-flex" *ngIf="user">
        <app-account-nav-menu [user]="user"></app-account-nav-menu>
      </div>
    </div>
  </div>
</mat-toolbar>
